import { FunctionComponent } from 'react'
import { CookWidget } from '@widgets/types'
import VideoYoutube from '@components/Video/Youtube'
import { YoutubeVideoProps } from '@components/Video/Youtube/types'

const Youtube: FunctionComponent<YoutubeVideoProps> = ({ videoId }) => {
  return <VideoYoutube videoId={videoId} />
}

const widget: CookWidget = {
  kind: ['widget', 'video', 'youtube'],
  component: Youtube,
}

export default widget
